export default "__VITE_ASSET__a943c990__"